import { render } from "./companyVue.vue?vue&type=template&id=5ad6a1ee&lang=true"
import script from "./companyVue.vue?vue&type=script&lang=js"
export * from "./companyVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__